import { createError, defineNuxtRouteMiddleware, useLogger } from "#imports";

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.client) return;

  const isStaticAsset =
    to.path.startsWith("/_nuxt/") ||
    to.path.startsWith("/assets/") ||
    to.path.startsWith("/static/") ||
    to.path.startsWith("/.well-known/") ||
    /\.(js|css|map|ico|png|jpg|jpeg|gif|svg|woff|woff2|ttf|eot)$/i.test(
      to.path,
    );

  if (isStaticAsset) {
    const logger = useLogger();

    logger.warning("Missing static asset requested via router", {
      pathname: to.path,
      fullPath: to.fullPath,
    });

    throw createError({
      statusCode: 404,
      statusMessage: "Asset not found",
    });
  }
});
